// src/pages/CareersPage.js
import React from "react";

import PageHero from "../components/PageHero";
import { ArrowIcon, MailIcon } from "../components/Icons";

const CAREERS_EMAIL = "anand@expertfinance.co.nz";
const CAREERS_SUBJECT = "Careers – Expression of Interest";

const WHAT_TO_SEND = [
  "Your CV or professional profile",
  "A short introduction about yourself",
  "The type of role you’re interested in (e.g. mortgage adviser, insurance specialist, client support, admin, etc.)",
];

function CareersPage() {
  const mailto = `mailto:${CAREERS_EMAIL}?subject=${encodeURIComponent(
    CAREERS_SUBJECT
  )}`;

  return (
    <div className="careers-page">
      <PageHero
        kicker="Careers"
        title="Careers at Expert Finance"
        subtitle="Nothing open right now. We still read everything that comes in."
        overlap
      />

      <section className="careers-section">
        {/* Status first, so nobody reads the whole page looking for a role */}
        <div className="careers-status">
          <span className="careers-status-badge">
            <span className="careers-status-dot" aria-hidden="true" />
            No open roles
          </span>
          <h2>We’re not hiring right now</h2>
          <p>
            Expert Finance is <strong>not recruiting for any open roles</strong>{" "}
            at the moment. The team we have is settled, and everyone is busy
            with client work.
          </p>
        </div>

        <div className="careers-block">
          <h2 className="careers-heading">
            If you want to be in the queue anyway
          </h2>
          <p className="careers-text">
            Roles do come up. If you would like to be considered when one does,
            send us:
          </p>

          <ol className="careers-steps">
            {WHAT_TO_SEND.map((item, index) => (
              <li key={item} className="careers-step">
                <span className="careers-step-number">{index + 1}</span>
                <span>{item}</span>
              </li>
            ))}
          </ol>

          <div className="careers-email">
            <div>
              <p className="careers-text">
                Please email your details to{" "}
                <a href={mailto}>{CAREERS_EMAIL}</a> with the subject line{" "}
                <strong>“{CAREERS_SUBJECT}”</strong>.
              </p>
            </div>
            <a href={mailto} className="pill-btn pill-btn-primary">
              <MailIcon />
              Email your details
              <ArrowIcon />
            </a>
          </div>
        </div>

        <div className="careers-block">
          <h2 className="careers-heading">We’ll keep your details on file</h2>
          <p className="careers-text">
            We look through these from time to time. If something suitable
            comes up, we may get in touch for a chat.
          </p>
          <p className="careers-text">Thanks for the interest either way.</p>
        </div>
      </section>
    </div>
  );
}

export default CareersPage;
